<template>
    <div>
     <div class="setting-drawer-index-handle"    :style="handleStyle" @click="toggle">
      <i class="el-icon-video-camera" v-if="!showType"></i>
      <i class="el-icon-close" v-else></i>
      </div>
     <el-drawer
      title="我是标题"
       
      :visible.sync="showType"
      :with-header="false"
      size="20%"
      @open="handleDrawerOpen"
      @close="handleDrawerClose"
      direction="rtl">
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/" 
        style="padding: 15px;"
        :file-list="fileList"  
        :auto-upload="false"  
        :disabled="true"  
        :show-file-list="true" 
        list-type="text"  
        class="upload-list-only" 
      >
        <!-- 隐藏上传按钮 -->
        <template #trigger>
          <div style="display: none;"></div>
        </template>

        <!-- 自定义文件列表项 -->
        <template #file="{ file }">
          <div class="custom-file-item">
            <!-- 文件信息 -->
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
        
            </div>
            <!-- 操作按钮 -->
            <div class="file-actions">
              <!-- 播放按钮 -->
              <el-button
                type="primary"
                size="mini"
                @click="handlePlay(file)"
                :disabled="!isPlayable(file.type)"
              >
                播放
              </el-button>
              <!-- 下载按钮 -->
              <el-button
                type="success"
                size="mini"
                @click="handleDownload(file)"
              >
                下载
              </el-button>
            </div>
          </div>
        </template>
      </el-upload>
   </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'BaseDrawer',
    props: {
        filelist: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
          fileList: [
        { name: 'file1.mp4', size: 1024 * 1024 * 5, type: 'video/mp4', url: 'path/to/file1.mp4' },
        { name: 'file2.pdf', size: 1024 * 500, type: 'application/pdf', url: 'path/to/file2.pdf' },
        { name: 'file3.mp3', size: 1024 * 1024 * 2, type: 'audio/mp3', url: 'path/to/file3.mp3' },
        { name: 'file4.jpg', size: 1024 * 300, type: 'image/jpeg', url: 'path/to/file4.jpg' },
      ],
            showType: false,
            drawerWidth: 0,
            isDrawerOpen: false,
        }
    },
    computed: {
    handleStyle() {
      if (this.isDrawerOpen) {
        return {
          right: `${this.drawerWidth-10}px`,
          transition: 'left 0.3s',
        };
      } else {
        return {
          right: '10px',
          transition: 'left 0.3s',
        };
      }
    },
   },
    methods: {
      formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      }
    },
    isPlayable(fileType) {
      const playableTypes = ['video/mp4', 'audio/mp3'];
      return playableTypes.includes(fileType);
    },
    // 播放文件
    handlePlay(file) {
      if (this.isPlayable(file.type)) {
        this.$message.success(`正在播放：${file.name}`);
        // 这里可以调用播放器的 API 或者打开一个新页面播放文件
      } else {
        this.$message.warning(`不支持播放此文件类型：${file.type}`);
      }
    },
    toggle () {
      this.$nextTick(() => {
        this.showType = !this.showType
      });
     
      
    },
    handleDrawerOpen() {
      this.isDrawerOpen = true;
      this.$nextTick(() => {
        this.calculateDrawerWidth();
      });
     
     
 
    },
    handleDrawerClose() {
      this.isDrawerOpen = false;
    },
    calculateDrawerWidth() {
      const drawer = document.querySelector('.el-drawer');
 
      if (drawer) {
        this.drawerWidth = drawer.offsetWidth;
      }
    },
    }
}
</script>

<style lang="scss">
.setting-drawer-index-handle {
    position: absolute;
    top: 240px;
    background: #1890ff;
    width: 48px;
    height: 48px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    pointer-events: auto;
    z-index: 1001;
    text-align: center;
    font-size: 16px;
    border-radius: 4px 0 0 4px;

    i {
      color: rgb(255, 255, 255);
      font-size: 20px;
    }
  }
.v-modal {
    display: none;
    z-index: -1;
  }
</style>